<template>
    <div style="margin-bottom: 10px">
        <router-link target="_blank"
                     :to="courseInfo.courseType==0 ? {name:'courseDetail',params: { courseId: courseInfo.courseId }}: {name:'courseOnlineDetail',params: { courseId: courseInfo.courseId }}">
            <dt class="course-cover">
                <div class="img-box hover-img-scale-box">
                    <img :src=courseInfo.coverFileUrl style="width:100%" alt="">
                </div>
            </dt>

            <div style="padding: 0 8px">
              <dt class="classList-introduce">
                {{courseInfo.courseTitle}}
              </dt>
              <dt class="classList-person">
                共 <span>{{courseInfo.subSectionNum}}</span> 节课 | <span>{{courseInfo.participationsCount}}</span>
                人报名
              </dt>
              <dt class="classList-price" v-if="!isLiveSignUp">
                <span class="free" v-if="$func.isTrue(courseInfo.isFree)">免费</span>
                <div v-else-if="$func.isTrue(courseInfo.isDiscount)">
                    <span class="price-span">
                        ￥{{courseInfo.discountPrice}}
                    </span>
                  <span class="old-price">￥{{courseInfo.coursePrice}}</span>
                  <a-tag class="discount-desc" color="orange">{{courseInfo.discountDesc}}</a-tag>
                </div>
                <span class="price-span" v-else>
                    ￥{{courseInfo.coursePrice}}
                </span>
              </dt>
            </div>
        </router-link>
    </div>
</template>

<script>
    import common from "../../mixin/common";
    export default {
        name: "CourseListItem",
        mixins: [common],
        props: {
            courseInfo: Object,
            isLiveSignUp: Boolean,
        },
        data() {
            return {
                title: ""
            }
        },
        methods: {
            //    滚动标题  courseInfo.courseTitle
            TitleScrolling() {
                setInterval(() => {
                    let head = this.courseInfo.courseTitle.substring(0, 1)
                    let foot = this.courseInfo.courseTitle.substring(1)
                    this.courseInfo.courseTitle = foot + head
                }, 800)
            }
        }
    }
</script>

<style scoped lang="less">

    .img-box {
        width: 100%;
        padding-top: 55%;
        position: relative;
        border-radius: 10px 10px 0 0;
        img {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            height: 100%;
        }
    }

    /*@import "../../styles/course.less";*/

    @first-font-size: 16px;

    dt {
        /*margin: 6px 0;*/
        height: 22px;
        /*line-height: 22px;*/
    }

    dt:nth-of-type(1) {
        height: auto;
        margin-bottom: 6px;
    }

    .free {
        color: #00CF8C;
        font-weight: 600;
        font-size: @first-font-size;
    }

    .price-span {
        font-size: @first-font-size;
    }

    .old-price {
        color: #999;
        text-decoration: line-through;
        font-size: 12px;
    }

    .discount-desc {
        float: right;
    }

    .discount-desc-phone {
        display: none;
    }

    /*  改  */
    .classList-introduce {
        //height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 1; //显示的行
    }

    .classList-person {
        color: #B7BBC4;

    }

    .classList-price {
        color: orangered;
    }


    @media (max-width: 576px) {
        /*//<=768的设备   手机，paid */
        .classList-person {
            font-size: 13px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
        }

        @first-font-size: 14px;
        .free {
            font-size: 14px;
        }

        .discount-desc-phone {
            /*display: block;*/
        }

    }

    @media (max-width: 992px) {
        .discount-desc {
            display: none;
        }

        .discount-desc-phone {
            display: inline-block;
            float: left;
        }
    }
    @media (min-width: 768px) {
        /*//>=768的设备   ipadpro */

    }

    @media (min-width: 992px) {
        /*//>=992的设备   小屏电脑*/

    }

    @media (min-width: 1200px) {
        /*//>=1200的设备   电脑*/
    }

    @media (min-width: 1600px) {
        /*//>=1200的设备  大屏电脑*/

    }


</style>
